import snakeCase from 'lodash/snakeCase';

import { EventContext, Fields } from '@vimeo/bigpicture-client';
import { TeamUser, Team } from '@vimeo/viewer';

import { createNullObject, PartialWithRequired } from './utils';

export const teamBpContextName = 'team_context';
export const teamBpContextSchemaVersion = 7;
export type TeamBpContext = Fields<typeof teamBpContextName, typeof teamBpContextSchemaVersion>;

const defaults = createNullObject([
  'joined_team_at',
  'resource_permission_level',
  'team_id',
  'team_size',
  'team_owner_id',
  'team_role',
  'team_subscription_type',
]);

export const buildTeamBpContext = (
  fields: PartialWithRequired<TeamBpContext, 'is_team_member'>,
) => {
  return {
    team_context: new EventContext(teamBpContextName, teamBpContextSchemaVersion, {
      ...defaults,
      ...fields,
    }),
  };
};

export const buildTeamBpContextFromTeamUser = (
  teamUser?: TeamUser,
  resource_permission_level?: TeamBpContext['resource_permission_level'],
) => {
  return {
    team_context: new EventContext(teamBpContextName, teamBpContextSchemaVersion, {
      is_team_member: Boolean(teamUser),
      team_owner_id: teamUser?.ownerId || null,
      team_subscription_type: teamUser?.accountType || null,
      team_role:
        (snakeCase(
          teamUser?.plainTextPermissionLevel?.toLowerCase(),
        ) as TeamBpContext['team_role']) || null,
      team_size: teamUser?.currentTeamSize || null,
      team_id: teamUser?.teamId || null,
      resource_permission_level: resource_permission_level || null,
      joined_team_at: teamUser?.joinedOn ? new Date(teamUser?.joinedOn).getTime() : null,
    }),
  };
};

export const buildTeamBpContextFromTeam = (team?: Team) => {
  return {
    team_context: new EventContext(teamBpContextName, teamBpContextSchemaVersion, {
      is_team_member: Boolean(team),
      team_owner_id: team?.ownerId || null,
      team_subscription_type: null,
      team_role: null,
      team_size: team?.currentTeamSize || null,
      team_id: null,
      resource_permission_level: null,
      joined_team_at: null,
    }),
  };
};
